/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/search-common';

const styles = {
  // Outlined neutral pill shown at the bottom of a sponsored search result card.
  sponsoredBadge: css`
    display: inline-flex;
    align-items: center;
    padding: 2px var(--cds-spacing-100);
    border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    border-radius: 999px;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    white-space: nowrap;
  `,
};

type Props = {
  color?: React.ComponentProps<typeof Typography2>['color'];
};

/**
 * "Sponsored" pill for partner-funded sponsored placements. Rendered after the card
 * metadata via the LearningProductCard postBadge slot when a hit has `sponsored: true`,
 * and inside TakeoverCard's dark-background footer (which passes color="invertBody").
 */
const SponsoredBadge = ({ color = 'body' }: Props) => (
  <Typography2
    component="span"
    variant="bodySecondary"
    color={color}
    css={styles.sponsoredBadge}
    data-testid="search-card-sponsored-badge"
  >
    {_t('Sponsored')}
  </Typography2>
);

export default SponsoredBadge;
